export default "__VITE_ASSET__1e852a6c__"